













import { computed, defineComponent } from '@vue/composition-api'
import { recalculateNet } from '@/libs/vatRecalcuations'
import { useTaxes } from '@/composable/useTaxes'
import MoneyAmountField from '@/components/common/MoneyAmountField.vue'
import type { BaseVat } from '@futureecom/futureecom-js/dist/services/tax-service'
import type { Money } from '@futureecom/futureecom-js'
import type { PriceRecalculationContext } from '@/types/PriceRecalculationContext'
import type { PropType } from '@vue/composition-api'

export default defineComponent({
  name: 'PriceGrossInput',

  components: { MoneyAmountField },

  props: {
    value: {
      type: Object as PropType<PriceRecalculationContext>,
      required: true
    },
    priceNetKey: {
      type: [] as PropType<'price' | 'sale_price'>,
      default: 'price'
    },
    priceGrossKey: {
      type: [] as PropType<'gross_price' | 'gross_sale_price'>,
      default: 'gross_price'
    },
    vat: {
      type: Object as PropType<BaseVat | null>,
      default: null
    }
  },

  setup(props, { emit, attrs }) {
    const { grossDisabled } = useTaxes()

    const priceGross = computed(() => props.value[props.priceGrossKey])

    const onPriceGrossChange = (value: Money | null): void => {
      if (grossDisabled.value || isDisabled.value || value?.amount == props.value[props.priceGrossKey]?.amount) {
        return
      }
      const canRecalculate = props.vat && value && !grossDisabled.value
      const recalculated = canRecalculate ? recalculateNet(value, props.vat) : value
      emit('input', { ...props.value, [props.priceNetKey]: recalculated, [props.priceGrossKey]: value })
    }

    const isDisabled = computed(() => grossDisabled.value || attrs.disabled)

    return {
      priceGross,
      isDisabled,
      onPriceGrossChange
    }
  }
})
